/**
 * Determines if a line intersects a circle based on four provided points
 *
 * @param {Point} uPoint - First point on first line
 * @param {Point} vPoint - Second point on first line
 * @param {Point} centerPoint - Center point of circle
 * @param {Point} radiusPoint - Point on radius of circle
 * @return {Boolean} If the line intersects the circle
 */

export default function lineIntersectsCircle(uPoint, vPoint, centerPoint, radiusPoint) {
  const endOne = { x: uPoint.x - centerPoint.x, y: uPoint.y - centerPoint.y }
  const endTwo = { x: vPoint.x - centerPoint.x, y: vPoint.y - centerPoint.y }
  const radiusSquared = Math.pow(radiusPoint.y - centerPoint.y, 2) + Math.pow(radiusPoint.x - centerPoint.x, 2)

  const a = Math.pow(endTwo.x - endOne.x, 2) + Math.pow(endTwo.y - endOne.y, 2)
  const b = 2 * (endOne.x * (endTwo.x - endOne.x) + endOne.y * (endTwo.y - endOne.y))
  const c = endOne.x * endOne.x + endOne.y * endOne.y - radiusSquared
  const discriminant = b * b - 4 * a * c

  if (discriminant <= 0) return false
  const p1 = (-b + Math.sqrt(discriminant)) / (2 * a)
  const p2 = (-b - Math.sqrt(discriminant)) / (2 * a)

  return (0 <= p1 && p1 <= 1) || (0 <= p2 && p2 <= 1)
}



// WEBPACK FOOTER //
// ./src/helpers/walls/lineIntersectsCircle.js